import React, { useState } from "react";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { ReactComponent as Search } from "assets/svgs/search.svg";
import { useGlobalContext } from "context/global";

const SearchIngredients = ({ hideInDesktop = false, handleSearch }) => {
	const { translation } = useGlobalContext();

	const [searchState, setSearchState] = useState({
		isSearchOpen: false,
		query: "",
	});

	const clearSearch = () => {
		setSearchState({ isSearchOpen: false, query: "" });
		handleSearch("");
	};

	const handleChange = (e) => {
		const search = e.target.value;
		setSearchState({ ...searchState, query: search });
		handleSearch(search);
	};

	return searchState.isSearchOpen ? (
		<div className={`${hideInDesktop ? "lg:hidden" : ""} flex items-center w-full md:w-2/4 px-2`}>
			<Search />
			<input
				autoFocus
				onKeyDown={(e) => e.key === "Escape" && clearSearch()}
				onChange={handleChange}
				className="border-b-[1px] m-4 w-full border-black focus:outline-none"
				type="text"
				aria-label={translation.other.searchIngredientsPlaceholder}
				placeholder={translation.other.searchIngredientsPlaceholder}
				value={searchState.query}
			/>
			<button className="animate-fade-in" onClick={clearSearch}>
				<Close className="w-5 h-5 cursor-pointer" />
			</button>
		</div>
	) : (
		<button
			className={`${hideInDesktop ? "lg:hidden" : ""} animate-fade-in mx-3 md:mx-0 relative top-1`}
			onClick={() => setSearchState({ ...searchState, isSearchOpen: true })}
		>
			<Search className="cursor-pointer" />
		</button>
	);
};

export default SearchIngredients;
